import React from 'react';
export function CreateIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.202 4.296L19.79 2.88A2.978 2.978 0 0017.67 2a2.98 2.98 0 00-2.118.873L15.425 3H4a1 1 0 00-1 1v8a1 1 0 102 0V5h8.418l-9.2 9.169a1 1 0 00-.228.375l-.015.036a.315.315 0 00-.019.049l-1.426 5.66a1 1 0 001.211 1.215l5.66-1.406c.019-.005.037-.013.054-.02a.448.448 0 01.04-.017 1 1 0 00.367-.223L19 10.724V20h-8a1 1 0 100 2h9a1 1 0 001-1V8.73l.192-.192a3 3 0 00.01-4.242zM5.462 16.835l1.661 1.667.081.08-2.328.578.585-2.325zm3.7.878L6.336 14.88l8.5-8.472 2.824 2.832-8.5 8.473zM19.783 7.122l-.709.706-2.824-2.833.708-.706a1 1 0 011.412.003l1.42 1.416a1 1 0 01-.007 1.414z"
  }));
}